import { Col, PageWrapper, Row } from '@qonsoll/react-design'

import { EmailAdvancedForm } from 'domains/Email/components'
import { HeaderBreadcrumbs } from 'components'
import { useHistory } from 'react-router-dom'
import { useTranslations } from 'contexts/Translation'

const EmailCreate = () => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting history instance */
  const history = useHistory()

  /* Configuring page header */
  const headingProps = {
    title: t('Email create'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  /* Function to handle back click */
  const handleBack = () => history.goBack()

  return (
    <PageWrapper
      onBack={handleBack}
      breadcrumbs={<HeaderBreadcrumbs />}
      headingProps={headingProps}>
      <Row noGutters>
        <Col cw={[12, 12, 10, 8, 7]}>
          <EmailAdvancedForm />
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default EmailCreate
